import { useLazyQuery } from '@apollo/client';
import { useEffect } from 'react';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import GetRecentSavedSearchesQuery from '@/graphql/contracts/getRecentSavedSearches.query.gql';
import { notificationService } from '@/services/notification/notification.client';
import { GetRecentSavedSearches, GetRecentSavedSearchesVariables } from
  '@/graphql/contracts/_generated_/getRecentSavedSearches.query';

const NUMBER_OF_SEARCH_TILES = 9;

export default function useGetRecentSavedSearches() {
  const [_getRecentSavedSearches, { data, loading }] =
    useLazyQuery<GetRecentSavedSearches, GetRecentSavedSearchesVariables>(
      GetRecentSavedSearchesQuery,
      {
        client: apolloClientContracts,
        onError: (err) => notificationService.open({
          title: 'Error',
          text: err.message,
          type: 'danger'
        }),
        fetchPolicy: 'network-only'
      }
    );

  const getRecentSavedSearches = () => {
    _getRecentSavedSearches({
      variables: {
        filter: {
          includePublicSearches: false,
          pageSize: NUMBER_OF_SEARCH_TILES,
          pageNumber: 1
        }
      }
    });
  };

  useEffect(() => {
    getRecentSavedSearches();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    getRecentSavedSearches,
    recentSavedSearches: data?.recentSavedSearches || [],
    isLoadingSavedSearches: loading
  } as const;
}
